import * as React from 'react';

function SvgLogout(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} {...props}>
      <defs>
        <clipPath id="logout_svg__a">
          <path d="M0 0h24v24H0z" data-name="Rectangle 306" fill={props.fill} stroke={props.fill} />
        </clipPath>
      </defs>
      <g data-name="Group 388" clipPath="url(#logout_svg__a)">
        <g data-name="Group 386">
          <path
            d="M12.642 24.005A10.705 10.705 0 015.073 5.73a1.647 1.647 0 012.329 2.329 7.41 7.41 0 1010.482 0 1.647 1.647 0 012.329-2.329 10.7 10.7 0 01-7.571 18.275z"
            data-name="Path 729"
            fill={props.fill}
          />
        </g>
        <g data-name="Group 387">
          <path
            d="M12.642 11.528a1.646 1.646 0 01-1.646-1.647V1.647a1.647 1.647 0 113.293 0v8.234a1.645 1.645 0 01-1.647 1.647z"
            data-name="Path 730"
            fill={props.fill}
          />
        </g>
      </g>
    </svg>
  );
}

export default SvgLogout;
